import { ValidationMessages } from './index'

export const ALERT_REQUIRED = 'Existem campos obrigatórios não preenchidos'
export const ALERT_INCORRECT_FIELDS = 'Existem campos preenchidos de forma incorreta'

export const messages: ValidationMessages = {
  beforeEqual130Years: (value, ...args) => `Não deve ser anterior a 130 anos da data atual.`,
  beforeEqualToday: (value, ...args) => `Deve ser igual ou anterior ao dia atual.`,
  celularInvalid: (value, ...args) => `O celular informado é inválido.`,
  cnpjInvalid: (value, ...args) => `O CNPJ informado é inválido.`,
  cpfInvalid: (value, ...args) => `O CPF informado é inválido.`,
  emailInvalid: (value, ...args) => `O e-mail informado é inválido.`,
  empty: (value, ...args) => `Não deve ser preenchido.`,
  invalid: (value, ...args) => `Campo inválido.`,
  length: (value, ...args) => `Deve possuir ${args[0]} caracteres.`,
  match: (value, ...args) => `Um ou mais caracteres informados não são permitidos para esse campo.`,
  maxLength: (value, ...args) => `Deve possuir no máximo ${args[0]} caracteres.`,
  maxRange: (value, ...args) => `Deve ser menor ou igual a ${args[0]}.`,
  minLength: (value, ...args) => `Deve possuir pelo menos ${args[0]} caracteres.`,
  minRange: (value, ...args) => `Deve ser maior ou igual a ${args[0]}.`,
  NaN: (value, ...args) => `Deve ser um número válido.`,
  nome: (value, ...args) => `Informe nome e sobrenome.`,
  nomeInvalido: (value, ...args) => `Deve conter apenas letras (acentuadas ou não).`,
  nomeOneLetter: (value, ...args) => `Nome e sobrenome não podem ter somente uma letra.`,
  nomeTwoLetters: (value, ...args) => `Nome e sobrenome não podem ter apenas duas letras.`,
  numericRange: (value, ...args) => `Deve ter entre ${args[0]} e ${args[1]} dígitos.`,
  pisInvalid: (value, ...args) => `O PIS informado é inválido.`,
  range: (value, ...args) => `Deve ter valor entre ${args[0]} e ${args[1]}.`,
  required: (value, ...args) => `Preenchimento obrigatório.`,
  requiredDomain: (value, ...args) => `Preenchimento obrigatório.`,
  senha: (value, ...args) => `Deve possuir letras e números.`,
  documentacaoRequired: (value, ...args) => `Documentação pendente.`,
  senhaSpecialChars: (value, ...args) => `Deve possuir apenas letras (não acentuadas) e números.`,
  telefoneInvalid: (value, ...args) => `O telefone informado é inválido.`,
  tituloEleitorInvalid: (value, ...args) => `O título de eleitor informado é inválido.`,
}
